<template>
  <v-app-bar app color="white" height="56" elevation="1">
    <div class="d-flex align-center font-weight-black mr-8">
      <svg
        style="height: 16px; margin-right: 16px;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 91.009 37.813"
      >
        <g id="layer1" transform="translate(-552.152 -554.556)">
          <path
            id="path2396"
            d="M552.152,554.556h10.633c3.933,0,5.219,1.84,6.468,3.734l12.508,18.973c.145.237.341.142.46,0L593.574,559.5c1.858-2.907,3.976-4.892,8.859-4.892h28.653c4.01,0,12.074,4.247,12.074,13.826,0,7.223-5.463,13.232-10.633,13.232-.2-.036-.26.206.1.744l6.645,9.839H628.824c-3.922,0-6.108-2.208-7.545-4.416l-1.366-2.1a8.144,8.144,0,0,0-6.156-3.554H601.684l4.505-6.718c2.046-3.051,4.4-3.811,9.218-3.811h11.552c5.142,0,4.682-6.51.1-6.51H609.5c-2.248,0-5.63,1.234-8.325,5.456l-10.813,16.94c-3.728,5.944-12.4,6.927-16.787,0Z"
            fill="#00b451"
            fill-rule="evenodd"
          />
        </g>
      </svg>

      DSP
    </div>

    <v-dialog
      v-if="selectedModal"
      :value="selectedModal"
      :width="selectedModal.width || 1000"
      persistent
    >
      <component :is="selectedModal.component" @close="onModalClose" />
    </v-dialog>

    <v-tabs>
      <template v-for="tab in tabs">
        <v-menu v-if="tab.isModalOnly" :key="tab.name" bottom :offset-y="true">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-tab :style="{ height: '100%', pointerEvents: 'none' }">{{
                tab.name
              }}</v-tab>
            </div>
          </template>
          <v-list class="grey lighten-3">
            <v-list-item
              v-for="tabChild in tab.children"
              :key="tabChild.name"
              @click="onModalLinkClick(tabChild)"
            >
              <v-list-item-content>
                <v-list-item-title v-text="tabChild.name" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          v-else-if="tab.children"
          :key="tab.name"
          bottom
          :offset-y="true"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-tab v-bind="attrs" v-on="on">
              <v-badge
                v-if="tab.count"
                color="primary"
                :content="tab.count"
                :value="tab.count"
                >{{ tab.name }}</v-badge
              >
              <template v-else>
                {{ tab.name }}
              </template>
            </v-tab>
          </template>

          <v-list class="grey lighten-3">
            <v-list-item
              v-for="tabChild in tab.children"
              :key="tabChild.name"
              :to="tabChild.path"
            >
              <v-list-item-content>
                <v-list-item-title v-text="tabChild.name" />
              </v-list-item-content>

              <v-list-item-avatar>
                <v-chip small v-if="tabChild.count" color="primary">
                  {{ tabChild.count }}
                </v-chip>
              </v-list-item-avatar>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tab v-else :to="tab.path" :key="tab.name" @click="onClickTab(tab)">
          <v-badge
            v-if="tab.count"
            color="primary"
            :content="tab.count"
            :value="tab.count"
            >{{ tab.name }}</v-badge
          >
          <template v-else>{{ tab.name }}</template>
        </v-tab>
      </template>
    </v-tabs>
    <v-spacer></v-spacer>
    <DistrictSelect />
    <EventRefetchButton v-if="$route.name === 'Dsp'" />
    <AppUserMenu />
  </v-app-bar>
</template>

<script>
import AppUserMenu from './AppUserMenu'
import EventRefetchButton from './EventRefetchButton'
import DistrictSelect from './DistrictSelect'
import DailyReport from '@/modules/report/DailyReport'
import VehicleReport from '@/modules/report/VehicleReport'
import QualityReport from '@/modules/report/QualityReport'
import paramsDistrict from '@/common/paramsDistrict.js'
import { get } from 'vuex-pathify'

export default {
  name: 'AppBar',

  components: {
    EventRefetchButton,
    AppUserMenu,
    DistrictSelect
  },

  data() {
    return {
      selectedModal: null
    }
  },

  computed: {
    selectedDistrictId: get('app/selectedDistrictId'),

    tabs() {
      const reportTabs = {
        isModalOnly: true,
        name: 'Rapporter',
        children: [
          {
            name: 'Dagrapport',
            component: DailyReport,
            width: 400
          },
          {
            name: 'Fordonsrapport',
            component: VehicleReport,
            width: 400
          },
          {
            name: 'Kvalitetsrapport',
            component: QualityReport,
            width: 400
          }
        ]
      }

      const odocTab = {
        name: 'Ödoc',
        path: `/${paramsDistrict(this.selectedDistrictId)}/odoc`,
        count: this.$store.get('odoc/countCases')
      }

      const tibBannerTab = {
        name: 'TIB Banner',
        path: `/${paramsDistrict(this.selectedDistrictId)}/tib-banner`,
        count: this.$store.get('tibBanner/count')
      }

      const tibSmsLogTab = {
        name: 'SMS logg',
        path: `/${paramsDistrict(
          this.$store.get('app/selectedDistrictId')
        )}/sms-log`
      }

      const tabs = [
        {
          name: 'Dashboard',
          path: `/${paramsDistrict(
            this.$store.get('app/selectedDistrictId')
          )}/event`
        },
        {
          name: 'Externa avvikelser',
          count: this.$store.get('linkDeviation/countTotalUnhandled'),
          visible:
            this.selectedDistrictId !== 21 && this.selectedDistrictId !== 22,

          children: [
            {
              name: 'Förseningar',
              path: `/${paramsDistrict(
                this.$store.get('app/selectedDistrictId')
              )}/link-deviation/delay`,
              count: this.$store.get('linkDeviation/countUnhandledDelays')
            },
            {
              name: 'Tågavvikelser',

              path: `/${paramsDistrict(
                this.$store.get('app/selectedDistrictId')
              )}/link-deviation/train-deviation`,
              count: this.$store.get(
                'linkDeviation/countUnhandledTrainDeviations'
              )
            },
            {
              name: 'Bemanningsavvikelser',
              visible: this.selectedDistrictId === 5,
              path: `/${paramsDistrict(
                this.$store.get('app/selectedDistrictId')
              )}/link-deviation/crew-deviation`,
              count: this.$store.get(
                'linkDeviation/countUnhandledCrewDeviations'
              )
            }
          ].filter(x => {
            if (x.visible === undefined) return true
            return x.visible
          })
        },
        {
          name: 'Historik',
          path: `/${paramsDistrict(
            this.$store.get('app/selectedDistrictId')
          )}/history`
        },
        {
          name: 'Stamdata',
          path: `/${paramsDistrict(
            this.$store.get('app/selectedDistrictId')
          )}/masterdata/reasons`
        },
        {
          name: 'Duwa',
          path: `/${paramsDistrict(
            this.$store.get('app/selectedDistrictId')
          )}/duwa`
        }
      ].filter(x => {
        if (x.visible === undefined) return true
        return x.visible
      })

      if (this.selectedDistrictId === 5) {
        tabs.push(odocTab)
        tabs.push(reportTabs)
      }

      if ([17].includes(this.selectedDistrictId)) {
        tabs.push(tibBannerTab)
        tabs.push(tibSmsLogTab)
      }

      if ([19].includes(this.selectedDistrictId)) {
        tabs.push(tibSmsLogTab)
      }

      return tabs
    }
  },

  methods: {
    onModalLinkClick(nextSelectedModal) {
      this.selectedModal = nextSelectedModal
    },
    onModalClose() {
      this.selectedModal = null
    },
    onClickTab() {
      this.$store.set('event/selectedUUID', null)
    }
  }
}
</script>
